import LightningIcon from '@/icons/lightning-orb'
import IconModal from '../icon-modal'

import styles from './InscriptionBalanceModal.module.css'

const InscriptionBalanceModal = (props: any) => {
	const { open, onClose } = props
	return (
		<IconModal
			open={open}
			onClose={onClose}
			title={'What is inscription balance?'}
			icon={() => <LightningIcon width={48} />}
			rootClassName={styles.root}
			bodyClassName={styles.body}
		>
			<p className={styles.paragraph}>
				Each inscription in your wallet contains a certain number of Satoshis within it. This number
				indicates how many Satoshis are inside your inscriptions.
			</p>
			<p className={styles.paragraph}>
				If you have too many Sats in an inscription, we will not allow you to list it until it is
				split. This is because it's possible you could send more bitcoins with the inscription
				itself than the sale amount.
			</p>
		</IconModal>
	)
}

export default InscriptionBalanceModal
